<template>
  <article class="kds-verdict-block">
    <KdsEyebrow class="kds-verdict-block__eyebrow">{{ eyebrow }}</KdsEyebrow>
    <h2 v-if="title" class="kds-verdict-block__title">{{ title }}</h2>
    <blockquote class="kds-verdict-block__quote">
      <KdsIcon
        name="quote"
        :size="24"
        class="kds-verdict-block__quote-icon"
      />
      <span class="kds-verdict-block__quote-text">{{ quote }}</span>
    </blockquote>
    <p class="kds-verdict-block__meta">{{ meta }}</p>
    <ul class="kds-verdict-block__rows">
      <KdsVerdictRow
        v-for="row in rows"
        :key="row.id"
        :tone="row.tone"
        :text="row.text"
      />
    </ul>
  </article>
</template>

<script setup lang="ts">
import KdsEyebrow from '@/kds/primitives/KdsEyebrow.vue';
import KdsIcon from '@/kds/primitives/KdsIcon.vue';
import KdsVerdictRow from './KdsVerdictRow.vue';
import type { KdsVerdictRowTone } from '@/kds/types';

interface VerdictRow {
  id: string;
  tone: KdsVerdictRowTone;
  text: string;
}

interface Props {
  eyebrow: string;
  quote: string;
  meta: string;
  rows: VerdictRow[];
  title?: string;
}

withDefaults(defineProps<Props>(), { title: undefined });
</script>

<style scoped lang="scss">
.kds-verdict-block {
  max-width: 880px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: var(--space-5);

  &__eyebrow {
    color: var(--stone);
  }

  &__title {
    margin: 0;
    font-family: var(--font-display);
    font-size: var(--fs-display-m);
    line-height: var(--lh-display-m);
    letter-spacing: var(--ls-display-m);
    color: var(--ink);
  }

  &__quote {
    display: grid;
    grid-template-columns: 24px 1fr;
    gap: var(--space-3);
    align-items: start;
    margin: 0;
    font-family: var(--font-serif);
    font-size: var(--fs-quote);
    line-height: var(--lh-quote);
    color: var(--ink);
  }

  &__quote-icon {
    color: var(--stone);
    margin-top: 6px;
  }

  &__meta {
    margin: 0;
    font-family: var(--font-mono);
    font-size: var(--fs-mono);
    color: var(--stone);
  }

  &__rows {
    list-style: none;
    margin: 0;
    padding: 0;
    border-top: var(--border);
  }
}
</style>
